export const WA_NUMBER = '9779764581986'      // wa.me link format: digits only, country code, no + or spaces
export const WA_DISPLAY = '+977 9764581986'   // human-readable format for on-page display
export const GUIDE_NAME = 'Lopsang Sherpa'

export const WA_MESSAGES = {
  general:  'Hi Lopsang, I found your website and I\'m interested in trekking in Nepal.',
  manaslu:  'Hi Lopsang, I am interested in the Manaslu Circuit Trek. Can you share availability and pricing?',
  annapurna:'Hi Lopsang, I am interested in the Annapurna Circuit Trek. Can you share details?',
  ebc:      'Hi Lopsang, I am interested in the Everest Base Camp Trek. Can you share details?',
  langtang: 'Hi Lopsang, I am interested in the Langtang Valley Trek. Can you share details?',
  gosaikunda:'Hi Lopsang, I am interested in the Langtang Gosaikunda Trek. Can you share details?',
  private:  'Hi Lopsang, I would like to discuss a private departure. What dates do you have available?',
  plan:     'Hi Lopsang, I would like help planning my Nepal trek. Can we start with dates and interests?',
}

export const SITE_META = {
  title:       'KTM Travel Guide — Licensed Kathmandu Trekking Guide',
  description: 'Licensed Kathmandu trekking guide. Small groups of 2–6. Manaslu Circuit specialist. Direct WhatsApp. No agencies.',
  url:         'https://ktmtravelguide.com',
}
